import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=045ea8a5&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=045ea8a5&prod&lang=scss"
import style1 from "./edit.vue?vue&type=style&index=1&id=045ea8a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ea8a5",
  null
  
)

export default component.exports